import makeStyles from "@mui/styles/makeStyles";

export default makeStyles(
  (theme) => ({
    root: {
      maxWidth: 288,
      padding: [11, 15, 28],
      [theme.breakpoints.up("mobile")]: {
        width: 429,
        maxWidth: "initial",
        padding: [16, 20, 40],
      },
    },
    title: {
      marginBottom: 18,
    },
    formControl: {
      marginBottom: 16,
      display: "flex",
    },
    radioGroup: {
      justifyContent: "center",
      width: "100%",
    },
    description: {
      marginBottom: 8,
    },
    actions: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      paddingTop: 16,
      paddingBottom: 16,
    },
  }),
  { name: "ShareModal-EmailForm" },
);
